import { Form, Radio, theme, Tooltip } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";

import MotionDiv from "./MotionDiv";

const PublicStatus = () => {
	const colorPrimary = theme.useToken().token.colorPrimary;

	return (
		<MotionDiv>
			<Form.Item
				name="isDisplayed"
				label={
					<div className="flex">
						<p className="font-bold">公開状態</p>
						<Tooltip
							overlayInnerStyle={{ width: 570 }}
							title={
								<div>
									<div>イベント一覧の表示・非表示制御です。</div>
									<div>■表示</div>
									<div>
										イベント予約可能期間に関わらず、イベント一覧に表示されます。
									</div>
									<div>■非表示</div>
									<div>イベント一覧から非表示になります。</div>
									<div>
										イベントURLをコピーして、イベントを知ってほしいユーザーにLINE配信してください。
									</div>
								</div>
							}
						>
							<QuestionCircleOutlined
								style={{ color: colorPrimary }}
								className="ml-2 mr-4"
							/>
						</Tooltip>
					</div>
				}
				rules={[
					{
						required: true,
						message: "表示状態を選択してください",
					},
				]}
				valuePropName="value"
				getValueProps={(value) => {
					if (typeof value === "string" && ["true", "false"].includes(value)) {
						return {
							value: value === "true",
						};
					}
					return {
						value,
					};
				}}
			>
				<Radio.Group
					buttonStyle="solid"
					optionType="button"
					options={[
						{ label: "表示", value: true },
						{ label: "非表示", value: false },
					]}
					className="[&_.ant-radio-button-wrapper]:w-[83px] [&_.ant-radio-button-wrapper]:text-center"
				/>
			</Form.Item>
		</MotionDiv>
	);
};

export default PublicStatus;
